import * as React from "react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "components/bootstrap";
import Icon from "components/common/Icon";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import { formatReadableNumber } from "util/NumberFormatting";
const ExpandedSectionCount = ({ entityId, section, count, label, abbreviate = false }, ref) => {
  var _a, _b;
  const { t } = useTranslation("common");
  const { expandedSections, toggleSection } = useExpandedSections();
  const isActive = (_b = (_a = expandedSections == null ? void 0 : expandedSections[entityId]) == null ? void 0 : _a.includes(section)) != null ? _b : false;
  return /* @__PURE__ */ React.createElement(
    Badge,
    {
      ref,
      color: isActive ? "primary" : void 0,
      variant: isActive ? "filled" : void 0,
      onClick: () => toggleSection(entityId, section),
      title: t(isActive ? "expanded_section_count.hide" : "expanded_section_count.show", { label })
    },
    abbreviate ? formatReadableNumber(count) : count,
    /* @__PURE__ */ React.createElement(Icon, { name: "dock_to_bottom", size: "xs", type: "regular" })
  );
};
export default forwardRef(ExpandedSectionCount);
